export default __webpack_public_path__ + "static/media/landing-page-provider-login.8ff7945e.svg";